const AuthConfig = {
  AccountInformation: 'AccountInformation', //
  DeleteApplication: 'DeleteApplication', // 删除应用
  /*================ 质保金 ================*/
  accountDetail: 'accountDetail', //质保金账户详情
  addAccount: 'addAccount', //补充生成账户
  retentionMoneyManagementAccountListExport: 'retentionMoneyManagementAccountListExport', //导出质保金账户
  editMoneyChange: 'editMoneyChange', //编辑质保金配置
  delMoneyChange: 'delMoneyChange', //删除质保金配置
  addMoneyChange: 'addMoneyChange', //新增质保金配置
  returnMoneyPhone: 'returnMoneyPhone', //质保金详情-查看手机号
  returnMoneyIdCard: 'returnMoneyIdCard', //质保金详情-查看身份证号
  /*================ 保险管理 ================*/
  createAccountBtnAuth: 'createAccountBtnAuth', //增加账户
  insureInfoRecharge: 'insureInfoRecharge', //手动充值
  insureInfoRecord: 'insureInfoRecord', //流水
  insureInfoContinue: 'insureInfoContinue', //手动续保
  insurancesettingOnAddOrEdit: 'insurancesettingOnAddOrEdit', //新增保险配置
  insurancesettingOnEdit: 'insurancesettingOnEdit', //编辑保险配置
  insurancesettingDelete: 'insurancesettingDelete', //删除保险配置
  /*================ 工人管理 ================*/
  addWorkerExternalPerson: 'addWorkerExternalPerson', //新增工人管理
  externalPersonViewDetail: 'externalPersonViewDetail', //工人管理详情
  externalPersonEdit: 'externalPersonEdit', //编辑工人
  lookPersonDetail: 'lookPersonDetail', //查看工人电话信息
  lookPersonDetailIdCard: 'lookPersonDetailIdCard', //查看工人身份证信息
  externalPersonBankEdit: 'externalPersonBankEdit', //编辑银行卡
  externalPersonBankDelete: 'externalPersonBankDelete', //删除银行卡
  externalPersonDimission: 'externalPersonDimission', //工人离职
  externalPersonActive: 'externalPersonActive', //工人启用
  externalPersonAddDept: 'externalPersonAddDept', //部门新增
  externalPersonDelDept: 'externalPersonDelDept', //部门删除
  lookElecContract: 'lookElecContract', //查看电子合同
  lookOfflineContract: 'lookOfflineContract', //查看线下合同
  externalPersonContractDelete: 'externalPersonContractDelete', //删除线下合同
  externalPersonBankCardAdd: 'externalPersonBankCardAdd', // 新增银行卡
  externalPersonContractAdd: 'externalPersonContractAdd', // 新增合同
  externalPersonAnnexAdd: 'externalPersonAnnexAdd', // 附件新增
  externalPersonElecContractAdd: 'externalPersonElecContractAdd', //发起电子合同
  externalPersonDeptState: 'externalPersonDeptState', //部门启用禁用

  /*================ 承包商配置 ================*/
  workerManagementViewDetail: 'workerManagementViewDetail', //承包商详情
  workerManagementEdit: 'workerManagementEdit', //承包商编辑
  workerManagementAdd: 'workerManagementAdd', //承包商新增
  lookWorkerDetail: 'lookWorkerDetail', //承包商查看证件信息
  authentication: 'authentication', //去认证和查看认证
  /*================ 服务管理 ================*/
  customerConfigAdd: 'customerConfigAdd', //服务管理新增
  customerConfigDel: 'customerConfigDel', //服务管理删除
  customerConfigDetail: 'customerConfigDetail', //服务管理详情
  customerConfigCopy: 'customerConfigCopy', //服务管理复制
  customerConfigEdit: 'customerConfigEdit', //服务管理编辑
  customerNodeListAdd: 'customerNodeListAdd', //服务节点新增
  customerNodeListEdit: 'customerNodeListEdit', //服务节点编辑
  customerNodeListDel: 'customerNodeListDel', //服务节点删除
  /*================ 节点配置 ================*/
  nodeConfigAdd: 'nodeConfigAdd', //节点配置新增
  nodeConfigDel: 'nodeConfigDel', //节点配置删除
  nodeConfigEdit: 'nodeConfigEdit', //节点配置编辑
  /*================ 客户管理报事报修 ================*/
  matterListEdit: 'matterListEdit', //编辑
  pendingListAdd: 'pendingListAdd', //建工单
  matterListPushIssueComment: 'matterListPushIssueComment', //推送评价
  matterListReply: 'matterListReply', //直接回复
  matterListAdd: 'matterListAdd', //新增
  matterListExport: 'matterListExport', //导出
  penddingChargePerson: 'penddingChargePerson', //添加责任人
  penddingDisposeLog: 'penddingDisposeLog', //新建处理记录
  penddingCallBackLog: 'penddingCallBackLog', //新建回访记录
  editDisposePerson: 'editDisposePerson', //批量修改处理人
  remindWorkerOrder: 'remindWorkerOrder', //催办、批量催办
  pendingListExport: 'pendingListExport', //导出
  pendingListEdit: 'pendingListEdit', //编辑
  pendingListReopen: 'pendingListReopen', //重新打开
  pendingListAccept: 'pendingListAccept', //受理
  pendingListReturn: 'pendingListReturn', //退回
  repairBtn: 'repairBtn', //回复

  customerChannelModificationPermissions: 'customerChannelModificationPermissions', // 销售计划客户来源编辑
  viewPhoneRights: 'viewPhoneRights', // 销售计划查看客户电话
  viewPhoneRights2: 'viewPhoneRights2', // 销售计划编辑客户电话
  salesPlan2: 'salesPlan2', // 改派tab权限

  // 线索管理
  preDispatchListTab: 'preDispatchListTab',
  allClueListTab: 'allClueListTab',
  clueImportTab: 'clueImportTab',

  /*================ 评价管理 ================*/
  evalutionConfigAdd: 'evalutionConfigAdd', //评价配置新增
  evalutionConfigEdit: 'evalutionConfigEdit', //评价配置编辑
  evalutionConfigCopy: 'evalutionConfigCopy', //评价配置复制
  evalutionConfigStatus: 'evalutionConfigStatus', //评价配置启用停用
  evalutionIndexAdd: 'evalutionIndexAdd', //评价指标新增
  evalutionIndexDel: 'evalutionIndexDel', //评价指标删除
  evalutionIndexEdit: 'evalutionIndexEdit', //评价指标编辑
  evalutionRecordEdit: 'evalutionRecordEdit', //分发记录处理
  evalutionRecordRemark: 'evalutionRecordRemark', //分发记录备注
  evalutionRecordLike: 'evalutionRecordLike', //分发记录赞点
  evalutionRecordDetail: 'evalutionRecordDetail', //分发记录详情
  evaluateRecordExport: 'evaluateRecordExport', //分发记录导出
  evalutionRecordModify: 'evalutionRecordModify', //分发记录修改
  // 无效列表
  YXBatchHighSeasPoolGet: 'YXBatchHighSeasPoolGet', //批量领取
  YXBatchHighSeasPoolAssign: 'YXBatchHighSeasPoolAssign', //批量指定分配
  YXHighSeasPoolGet: 'YXHighSeasPoolGet', //领取
  YXHighSeasPoolAssign: 'YXHighSeasPoolAssign', //指定分配
  salePublicInfoViewPhone: 'salePublicInfoViewPhone', //查看电话
  // 飞单列表
  SJBatchHighSeasPoolGet: 'SJBatchHighSeasPoolGet', //批量领取
  SJBatchHighSeasPoolAssign: 'SJBatchHighSeasPoolAssign', //批量指定分配
  SJHighSeasPoolGet: 'SJHighSeasPoolGet', //领取
  SJHighSeasPoolAssign: 'SJHighSeasPoolAssign', //指定分配
  DesignPublicInfoViewPhone: 'DesignPublicInfoViewPhone', //查看电话
  // 酷家乐
  kuklerAccountAddBtn: 'kuklerAccountAddBtn', //新增
  kuklerAccountEditBtn: 'kuklerAccountEditBtn', //编辑
  kuklerAccountDelBtn: 'kuklerAccountDelBtn', //删除
  kuklerAccountImportBtn: 'kuklerAccountImportBtn', //导入
  kuklerAccountUseRecordBtn: 'kuklerAccountUseRecordBtn', //领用记录
  kuklerAccountDownloadBtn: 'kuklerAccountDownloadBtn', //下载模板
  kuklerAccountGetBtn: 'kuklerAccountGetBtn', //领取账号
  kuklerAccountReleaseBtn: 'kuklerAccountReleaseBtn', //释放账号
  updateKjlInfoBtn: 'updateKjlInfoBtn', //更新酷家乐账户信息
  kjlCheckThePwdBtn: 'kjlCheckThePwdBtn', // 酷家乐查看密码

  // 销售运营
  clueInfoEdit: 'clueInfoEdit', //编辑商机（线索）
  trackInfoEdit: 'trackInfoEdit', //编辑销售计划（需求）
  // 商机运营 已入库线索
  warehousingClueExportBtn: 'warehousingClueExportBtn', // 导出
  collisionClueExportBtn: 'collisionClueExportBtn', // 导出（不含撞单）
  clueDispatchViewPhone: 'clueDispatchViewPhone', // 查看电话
  // 商机运营 列表
  ClueExportButton: 'ClueExportButton', // 导出
  ClueExportDetailsButton: 'ClueExportDetailsButton', // 导出明细
  ClueExportZipButton: 'ClueExportZipButton', // 导出（Zip）
  clueEditPhone: 'clueEditPhone', // 编辑电话
  clueViewPhone: 'clueViewPhone', // 查看电话
  batchReassignmentSale: 'batchReassignmentSale', // 批量改派营销员
  reassignmentSale: 'reassignmentSale', // 改派营销员

  // 销售计划
  salePlanViewPhone: 'salePlanViewPhone', // 查看电话
  batchReassignmentDesigner: 'batchReassignmentDesigner', // 批量改派设计师
  reassignmentDesigner: 'reassignmentDesigner', // 改派设计师

  // 异常列表
  errorListViewPhone: 'errorListViewPhone', // 查看电话
  // exceptionContinueBtn: 'exceptionContinueBtn', // 继续派单

  // 智能外呼
  CallClueAdd: 'CallClueAdd', // 新增
  CallClueTransfer: 'CallClueTransfer', // 改派云客服
  CallCluePickFromOcean: 'CallCluePickFromOcean', // 领取线索
  SubmitThePending: 'SubmitThePending', // 提交待定
  CallClueAssignOrders: 'CallClueAssignOrders', // 指定派单
  CallClueAssign: 'CallClueAssign', // 派单
  SubmitTheInvalid: 'SubmitTheInvalid', // 提交无效
  appointment2StoreForCall: 'appointment2StoreForCall', // 预约到店
  submitValidForCall: 'submitValidForCall', // 提交有效
  CallClueEdit: 'CallClueEdit', // 编辑
  callViewPhone: 'callViewPhone', // 查看电话

  /** 字段权限 **/
  // STORAGE_VIEW_ALL_PRICE: 'STORAGE_VIEW_ALL_PRICE',

  //收款服务
  AbnormalErrorList: 'AbnormalErrorList', //异常列表
  AbnormalErrorEdit: 'AbnormalErrorEdit', //列表操作价格明细
  AbnormalErrorRetry: 'AbnormalErrorRetry', //列表操作重试
  AbnormalErrorClose: 'AbnormalErrorClose', //列表操作关闭
  ReceivableListAuth: 'ReceivableListAuth', //应收明细tabs
  ReceivableListAdd: 'ReceivableListAdd', //新增
  ReceivableListRule: 'ReceivableListRule', //联查收款计划
  ReceivableListChangeRule: 'ReceivableListChangeRule', //变更收款计划
  ReceivableListMergeReceipts: 'ReceivableListMergeReceipts', //合并收款
  ReceivableListReceipts: 'ReceivableListReceipts', //列表操作收款
  ReceivableListWriteOffModal: 'ReceivableListWriteOffModal', //列表操作核销
  ReceivableListVerifyApplyModal: 'ReceivableListVerifyApplyModal', //列表操作核销查询
  ReceivableListQRCode: 'ReceivableListQRCode', //列表操作收款二维码
  ReceivableListEdit: 'ReceivableListEdit', //列表操作提交
  PaymentDetailsAuth: 'PaymentDetailsAuth', //收款明细tabs
  PaymentDetailsAdd: 'PaymentDetailsAdd', //新增
  PaymentDetailsTransferFunds: 'PaymentDetailsTransferFunds', //转款
  PaymentDetailsTransfer: 'PaymentDetailsTransfer', //转款查询
  PaymentDetailsWriteOff: 'PaymentDetailsWriteOff', //列表操作核销
  PaymentDetailsEdit: 'PaymentDetailsEdit', //列表操作编辑
  PaymentDetailsVerifyApplyModal: 'PaymentDetailsVerifyApplyModal', //列表操作核销查询
  PaymentDetailsReceipt: 'PaymentDetailsReceipt', //列表操作确认收款
  PaymentDetailsConfirmReceipt: 'PaymentDetailsConfirmReceipt', //列表操作确认到账
  PaymentDetailsCustomerCopyPrint: 'PaymentDetailsCustomerCopyPrint', //列表操作打印客户联
  PaymentDetailsAccountCopyPrint: 'PaymentDetailsAccountCopyPrint', //列表操作打印记账联
  PaymentDetailsSendReceipt: 'PaymentDetailsSendReceipt', //列表操作发送收据信息
  PaymentDetailsModifyAmount: 'PaymentDetailsModifyAmount', //列表操作修改收款金额
  PaymentDetailsDel: 'PaymentDetailsDel', //列表操作删除
  ReceiptCreateMsgLog: 'ReceiptCreateMsgLog', //重发金蝶收款信息
  VerificationDetailsAuth: 'VerificationDetailsAuth', //核销明细tabs
  VerificationDetailsCancel: 'VerificationDetailsCancel', //取消核销
  VerificationDetailsCancelReceivable: 'VerificationDetailsCancelReceivable', //取消核销
  VerificationDetailsCancelPayment: 'VerificationDetailsCancelPayment', //取消核销
  ReceivableListMakeEffective: 'ReceivableListMakeEffective', //生效
  RefundConfirmationAuth: 'RefundConfirmationAuth', //退款明细tabs
  RefundConfirmationSkip: 'RefundConfirmationSkip', //去退款
  RefundConfirmationConfirm: 'RefundConfirmationConfirm', //确认退款
  RefundConfirmationRefunded: 'RefundConfirmationRefunded', //已退款
  RefundConfirmationHandle: 'RefundConfirmationHandle', //列表操作处理
  RefundConfirmationEdit: 'RefundConfirmationEdit', //列表操作修改
  RefundConfirmationUpdatePaymentStatus: 'RefundConfirmationUpdatePaymentStatus', //列表操作更新支付状态
  RefundConfirmationChangeRecord: 'RefundConfirmationChangeRecord', //列表操作变更历史
  InvoiceRegistrationAuth: 'InvoiceRegistrationAuth', //发票登记tabs
  InvoiceRegistrationAdd: 'InvoiceRegistrationAdd', //新增
  InvoiceRegistrationEdit: 'InvoiceRegistrationEdit', //列表操作编辑
  InvoiceRegistrationDel: 'InvoiceRegistrationDel', //列表操作删除
  collectionCountAuth: 'collectionCountAuth', //收款计算
  newCollectionCountAuth: 'newCollectionCountAuth', //新收款计算
  UpdateKingdeeCustomers: 'UpdateKingdeeCustomers', //更新金蝶客户
  AddWhiteList: 'AddWhiteList', //新增白名单
  ReceivableListDelete: 'ReceivableListDelete', //删除
  couponQueryAuth: 'couponQueryAuth', //优惠券查询
  // 业财组织转换

  // 销售工作台
  salesWorkBenchClueExportButton: 'salesWorkBenchClueExportButton', //导出
  salesWorkBenchClueExportDetailsButton: 'salesWorkBenchClueExportDetailsButton', //导出明细
  salesWorkBenchClueExportZipButton: 'salesWorkBenchClueExportZipButton', //导出（Zip）
  salesWorkBenchClueInfoEdit: 'salesWorkBenchClueInfoEdit', //编辑
  salesWorkBenchTrackInfoEdit: 'salesWorkBenchTrackInfoEdit', //编辑商机
  salesWorkBenchReassignmentSale: 'salesWorkBenchReassignmentSale', //改派营销员
  salesWorkBenchReassignmentSeat: 'salesWorkBenchReassignmentSeat', //改派云客服
  salesWorkBenchBatchReassignmentDesign: 'salesWorkBenchBatchReassignmentDesign', //批量改派设计师
  salesWorkBenchBatchReassignmentSale: 'salesWorkBenchBatchReassignmentSale', //批量改派营销员
  salesWorkBenchBatchReassignmentSeat: 'salesWorkBenchBatchReassignmentSeat', //批量改派云客服
  salesWorkBenchSeatSearchClueRepeat: 'salesWorkBenchSeatSearchClueRepeat', //线索查重
  salesWorkBenchAddLog: 'salesWorkBenchAddLog', //写日志
  salesWorkBenchReassignmentDesigner: 'salesWorkBenchReassignmentDesigner', //改派设计师
  salesWorkBenchClueViewPhone: 'salesWorkBenchClueViewPhone', //电话号码查看
  salesWorkBenchClueEditPhone: 'salesWorkBenchClueEditPhone', //电话号码编辑
  salesWorkBenchClueAdd: 'salesWorkBenchClueAdd', //新增线索
  salesWorkBenchClueAddBySeat: 'salesWorkBenchClueAddBySeat', //新增线索（云客服）
  salesWorkBenchClueAddByChannel: 'salesWorkBenchClueAddByChannel', //新增线索（渠道）
  salesWorkBenchViewCustomerProfile: 'salesWorkBenchViewCustomerProfile', //查看档案
  salesDeliveryTimeField: 'salesDeliveryTimeField', //编辑交房时间
  // 状态Tab按钮
  AllTab: 'AllTab', //全部
  saleWorkBenchPendingDispatchSaleTab: 'saleWorkBenchPendingDispatchSaleTab', //待派单
  saleWorkBenchClueBeginStatusTab: 'saleWorkBenchClueBeginStatusTab', //信息
  saleWorkBenchStateClueTab: 'saleWorkBenchStateClueTab', //全线索部
  saleWorkBenchStateCluePendingTab: 'saleWorkBenchStateCluePendingTab', //待定线索
  saleWorkBenchStateVaildClueTab: 'saleWorkBenchStateVaildClueTab', //有效线索
  saleWorkBenchStateClueReservationTab: 'saleWorkBenchStateClueReservationTab', //预约线索
  saleWorkBenchStateClueToDesignTab: 'saleWorkBenchStateClueToDesignTab', //已转设计
  saleWorkBenchStateClueToShopTab: 'saleWorkBenchStateClueToShopTab', //到店线索
  saleWorkBenchClueCallPendingTab: 'saleWorkBenchClueCallPendingTab', //呼叫待定
  saleWorkBenchClueCallValidTab: 'saleWorkBenchClueCallValidTab', //呼叫有效
  saleWorkBenchClueDispatchTab: 'saleWorkBenchClueDispatchTab', //派单
  saleWorkBenchPublicSeatTab: 'saleWorkBenchPublicSeatTab', //呼叫公海
  saleWorkBenchPublicSaleTab: 'saleWorkBenchPublicSaleTab', //营销公海
  saleWorkBenchPublicDesignTab: 'saleWorkBenchPublicDesignTab', //设计公海
  // 外呼接入
  channelCallBackOutBoundTab: 'channelCallBackOutBoundTab', //通道回调配置
  seatingOutBoundTab: 'seatingOutBoundTab', //坐席配置
  lineAllocationOutBoundTab: 'lineAllocationOutBoundTab', //线路分配

  viewCaseBtn: 'viewCaseBtn', //去提案大师
  designMasterBtn: 'designMasterBtn', //去设计大师

  assignChannelPeople: 'assignChannelPeople', //绑定渠道人员
  assignSeatMan: 'assignSeatMan', //关联云客服
  assignDeliveryAchievement: 'assignDeliveryAchievement', //关联交付业绩人员
  priceImportAuthKey: 'priceImportAuthKey', //价格策略--价格导入
  promngAuthKey: 'promngAuthKey', //价格策略--项目经理利率
  grossAuthKey: 'grossAuthKey', //价格策略--毛利
  boostAuthKey: 'boostAuthKey', //价格策略--提点率
  generalPriceAuthKey: 'generalPriceAuthKey', //价格策略--通项价格
  priceSearchAuthKey: 'priceSearchAuthKey', //价格策略--价格查询

  //   量房管理
  editAppointmentInfo: 'editAppointmentInfo', //修改预约信息
  editMeasurePeople: 'editMeasurePeople', //修改量房人
  cancelMeasure: 'cancelMeasure', //取消
  enterMeasureData: 'enterMeasureData', //录入量房数据
  editMeasureData: 'editMeasureData', //编辑量房数据
  measureReview: 'measureReview', //发起量房报告审核
  measureShare: 'measureShare', //推送量房报告
  measureReport: 'measureReport', //查看量房报告

  // sku
  productPriceQuery_purchasePrice: 'productPriceQuery_purchasePrice', // 采购价查询
  productPriceQuery_marketPrice: 'productPriceQuery_marketPrice', // 市场价查询
  productPriceQuery_projectManagerPrice: 'productPriceQuery_projectManagerPrice', // 项目经理价查询
  productPriceQuery_customerPrice: 'productPriceQuery_customerPrice', // 客户价查询
  productPriceQuery_sendPackPrice: 'productPriceQuery_sendPackPrice', // 发包价查询
  showMaterialChannelPrice: 'showMaterialChannelPrice', // 材料渠道价查询
  skuBatchImport: 'skuBatchImport', //sku批量导入
  skuBatchExport: 'skuBatchExport', //sku批量导出
  skuAllSelect: 'skuAllSelect', //sku列表数据全选
  skuBatchEnable: 'skuBatchEnable', //sku批量启用
  skuBatchDisable: 'skuBatchDisable', //sku批量禁用
  skuAddToStandard: 'skuAddToStandard', //sku添加到通项标配
  orderCollectionCountAuth: 'orderCollectionCountAuth', // 订单收款计算
  orderSendReceipt: 'orderSendReceipt', // 订单收款计算
  orderDownloadReceipt: 'orderDownloadReceipt', // 订单收款计算
  //   SPU管理
  toEditCombinationBtn: 'toEditCombinationBtn', // 组合明细-》去编辑
}

export default AuthConfig
